import { isMobile } from 'react-device-detect'
import AssetMedia from '@/components/AssetMedia'
import galleryImageLoader from '@/helpers/galleryImageLoader'
import { Asset } from '@/types/assets'

interface NftResultProps {
  asset: Asset
  onAssetClick: (asset: Asset) => void
}

export function NftResult({ asset, onAssetClick }: NftResultProps) {
  return (
    <button
      type="button"
      onClick={() => onAssetClick(asset)}
      className="overflow-hidden rounded-lg bg-black/5 focus:outline-2 focus:outline-offset-2 focus:outline-brand-500 dark:bg-white/5"
    >
      <div className="relative aspect-square overflow-hidden">
        <AssetMedia
          src={asset.imageUrl}
          alt={asset.id.toString()}
          className="object-cover w-full h-full"
          loader={galleryImageLoader}
          sizes="(max-width: 640px) 100vw, 360px"
          fill
          options={{ optimizeGifs: true, stateBgColor: 'transparent' }}
          videoJsOptions={{
            preload: isMobile ? 'auto' : 'metadata',
            controls: isMobile,
            fluid: true,
            fill: true
          }}
        />
      </div>
    </button>
  )
}
